import { createSelector } from '@app/utils/createSelector'

import type { ApiPlaygroundEventType } from '@app/packages/api/v2/types/entities'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { createReduxSlice } from '@app/store/redux_slice'

const playgroundEventTypesSlice = createReduxSlice<SliceState<ApiPlaygroundEventType[]>>('playground_event_types')

export const playgroundEventTypesResultSelector = createSelector([playgroundEventTypesSlice.selector], sliceState =>
  createLoadable(c =>
    withCheckedSliceState(c, {
      sliceState,
      slice: playgroundEventTypesSlice,
      load: async dispatch => {
        const [{ getPlaygroundRequestsEventTypes }, { callV2Api }] = await Promise.all([
          import('@app/packages/api/v2/actions/playground_requests'),
          import('@app/store/actions/api'),
        ])
        return (await dispatch(callV2Api(getPlaygroundRequestsEventTypes()))).data
      },
    })
  )
)
